!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (window.define)
		define('hotels/showAllHotelsInCity',['libs/ct_view', 'hotels/filter'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.View, CT.settings.filters) // CT.settings.showAllHotelsView

}('showAllHotelsView', function(View, filters) {

	var showAllHotelsSettings = {


		events : {
			'click button' : 'showAllHotels'
		},


		showAllHotels : function() {
			filters.ShowAllData();
			this.$el.hide();
		},



		showData : function(e) {
			this.$el.show();
			//this.$mid.find('.showAllInCity span').html(CT.areaVal);
			$(this.$mid.find('.listViewResults .lineMessage')[0]).find('span').html(CT.areaVal);
			this.$mid.find('#' + CT.areaVal.replace(/ /g, '_')).trigger('click').attr('checked', 'checked');
		}
	};



	//CT.subscribe('initShowAllInCity', function(mObj) {
	CT.subscribe('showAreaData.init', function(mObj) {

		showAllHotelsSettings.$el = $($("#ResultContainer_"+CT.settings.currentTab).find('.listViewResults .lineMessage')[0]);
		showAllHotelsSettings.$mid = $("#ResultContainer_"+CT.settings.currentTab);

		var showAllView = View(showAllHotelsSettings);
		//@todo-discuss with parag.
		//var showAllHotels = CT.settings.showAllHotelsView;
		//TODO: commented out - karthik
		//showAllView.showData();

		//CT.cache.views[CT.settings.currentTab].shAll = showAllView;
	});



	return showAllHotelsSettings;
}, CT.settings);

